module.exports = __webpack_public_path__ + "0a023299f4b0fd65a52383ab060d010f.png";